import useCreateNeighborhoodPrice from 'modules/companies/hooks/use-create-neighborhood-price';
import useEditNeighborhoodPrice from 'modules/companies/hooks/use-edit-neighborhood-price';
import {
  CompanyNeighborHoodPriceProps,
  translatedCompanyNeighborHoodPriceProps,
} from 'modules/companies/types';
import useCityNeighborhoodsByCompanySelect from 'modules/neighborhoods/hooks/use-city-neighborhoods-by-company-select';

import React from 'react';
import {useParams} from 'react-router-dom';
import Edition from 'shared/layout/edition';
import useFormInputs from 'shared/migration-components/form/util';

const EditNeighborhoodPrice: React.FC = () => {
  const {getSelect, getPriceInput} =
    useFormInputs<CompanyNeighborHoodPriceProps>();
  const {id, companyNeighborhoodPriceId} = useParams();

  const {data, isLoading} = useCityNeighborhoodsByCompanySelect(id!);

  return (
    <Edition<CompanyNeighborHoodPriceProps>
      {...{
        detailsUrl: `/neighborhoods/company-prices/${companyNeighborhoodPriceId}`,
      }}
      onSubmit={() =>
        useEditNeighborhoodPrice(id!, companyNeighborhoodPriceId!)
      }
      inputs={[
        getSelect({
          name: 'neighborhoodId',
          data,
          isLoading,
        }),
        getPriceInput({name: 'deliveryPrice'}),
        getPriceInput({name: 'deliveryManFee'}),
      ]}
      translationKey={translatedCompanyNeighborHoodPriceProps}
    />
  );
};

export default EditNeighborhoodPrice;
